"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getStateFromPath_exports = {};
__export(getStateFromPath_exports, {
  getStateFromPath: () => getStateFromPath
});
module.exports = __toCommonJS(getStateFromPath_exports);
var import_escape_string_regexp = __toESM(require("escape-string-regexp"), 1);
var import_shared = require("./_shared");
var import_findFocusedRoute = require("./findFocusedRoute");
var import_getStateFromPath_mods = require("./getStateFromPath-mods");
var import_validatePathConfig = require("./validatePathConfig");
function getStateFromPath(path, options) {
  var _options_path;
  resetRouteKeyCounter();
  if (process.env.ONE_DEBUG_ROUTER) {
    console.info(`[one] getStateFromPath called with path=${path}, isServer=${typeof window === "undefined"}`);
  }
  var { initialRoutes, configs, configWithRegexes } = getConfigResources(options);
  var screens = options === null || options === void 0 ? void 0 : options.screens;
  var pathData = (0, import_getStateFromPath_mods.getUrlWithReactNavigationConcessions)(path);
  var remaining = pathData.nonstandardPathname.replace(/\/+/g, "/").replace(/^\//, "").replace(/\?.*$/, "");
  remaining = remaining.endsWith("/") ? remaining : `${remaining}/`;
  var prefix = options === null || options === void 0 ? void 0 : (_options_path = options.path) === null || _options_path === void 0 ? void 0 : _options_path.replace(/^\//, "");
  if (prefix) {
    var normalizedPrefix = prefix.endsWith("/") ? prefix : `${prefix}/`;
    if (!remaining.startsWith(normalizedPrefix)) {
      return void 0;
    }
    remaining = remaining.replace(normalizedPrefix, "");
  }
  if (screens === void 0) {
    var routes = remaining.split("/").filter(Boolean).map(function(segment) {
      var name = decodeURIComponent(segment);
      return {
        name
      };
    });
    if (routes.length) {
      return createNestedStateObject(pathData, routes, initialRoutes, []);
    }
    return void 0;
  }
  if (remaining === "/") {
    var match = (0, import_getStateFromPath_mods.matchForEmptyPath)(configWithRegexes);
    if (match) {
      return createNestedStateObject(
        pathData,
        // @modified: pass pathData instead of path
        match.routeNames.map(function(name) {
          return {
            name
          };
        }),
        initialRoutes,
        configs
      );
    }
    return void 0;
  }
  var result;
  var current;
  var { routes: routes1, remainingPath } = matchAgainstConfigs(remaining, configWithRegexes);
  if (routes1 !== void 0) {
    current = createNestedStateObject(pathData, routes1, initialRoutes, configs);
    remaining = remainingPath;
    result = current;
  }
  if (current == null || result == null) {
    return void 0;
  }
  return result;
}
var cachedConfigResources = /* @__PURE__ */ new WeakMap();
function getConfigResources(options) {
  if (!options) return prepareConfigResources();
  var cached = cachedConfigResources.get(options);
  if (cached) return cached;
  var resources = prepareConfigResources(options);
  cachedConfigResources.set(options, resources);
  return resources;
}
function prepareConfigResources(options, previousSegments) {
  if (options) {
    (0, import_validatePathConfig.validatePathConfig)(options);
  }
  var initialRoutes = getInitialRoutes(options);
  var configs = getNormalizedConfigs(initialRoutes, options === null || options === void 0 ? void 0 : options.screens, previousSegments);
  checkForDuplicatedConfigs(configs);
  var configWithRegexes = getConfigsWithRegexes(configs);
  return {
    initialRoutes,
    configs,
    configWithRegexes
  };
}
function getInitialRoutes(options) {
  var initialRoutes = [];
  if (options === null || options === void 0 ? void 0 : options.initialRouteName) {
    initialRoutes.push({
      initialRouteName: options.initialRouteName,
      parentScreens: []
    });
  }
  return initialRoutes;
}
function getNormalizedConfigs(initialRoutes) {
  var screens = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, previousSegments = arguments.length > 2 ? arguments[2] : void 0;
  return [].concat(...Object.keys(screens).map(function(key) {
    return createNormalizedConfigs(key, screens, [], initialRoutes, []);
  })).map((0, import_getStateFromPath_mods.appendIsInitial)(initialRoutes)).sort((0, import_getStateFromPath_mods.getRouteConfigSorter)(previousSegments));
}
function checkForDuplicatedConfigs(configs) {
  configs.reduce(function(acc, config) {
    if (acc[config.pattern]) {
      var a = acc[config.pattern].routeNames;
      var b = config.routeNames;
      var intersects = a.length > b.length ? b.every(function(it, i) {
        return a[i] === it;
      }) : a.every(function(it, i) {
        return b[i] === it;
      });
      if (!intersects) {
        throw new Error(`Found conflicting screens with the same pattern. The pattern '${config.pattern}' resolves to both '${a.join(" > ")}' and '${b.join(" > ")}'. Patterns must be unique and cannot resolve to more than one screen.`);
      }
    }
    return Object.assign(acc, {
      [config.pattern]: config
    });
  }, {});
}
function getConfigsWithRegexes(configs) {
  return configs.map(function(c) {
    return {
      ...c,
      // Add `$` to the regex to make sure it matches till end of the path and not just beginning
      // @modified - start
      // regex: c.regex ? new RegExp(c.regex.source + '$') : undefined,
      regex: c.pattern ? new RegExp(`^(${c.pattern.split("/").map(import_getStateFromPath_mods.formatRegexPattern).join("")})$`) : void 0
    };
  });
}
var joinPaths = function joinPaths2() {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }
  return [].concat(...paths.map(function(p) {
    return p.split("/");
  })).filter(Boolean).join("/");
};
var matchAgainstConfigs = function matchAgainstConfigs2(remaining, configs) {
  var routes;
  var remainingPath = remaining;
  var allParams = /* @__PURE__ */ Object.create(null);
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    var _loop = function() {
      var config = _step.value;
      if (!config.regex) {
        return "continue";
      }
      var match = remainingPath.match(config.regex);
      if (match) {
        var _config_pattern;
        var matchResult = (_config_pattern = config.pattern) === null || _config_pattern === void 0 ? void 0 : _config_pattern.split("/").reduce(
          // Position of the current path param segment in the path (e.g in pattern `a/:b/:c`, `:a` is 0 and `:b` is 1)
          // The extracted params
          function(acc, p, index) {
            if (!(0, import_shared.isDynamicPart)(p)) {
              return acc;
            }
            acc.pos += 1;
            var decodedParamSegment = (0, import_getStateFromPath_mods.decodeURIComponentSafe)(
              // @modified: use decodeURIComponent**Safe**
              // The param segments appear every second item starting from 2 in the regex match result
              match[(acc.pos + 1) * 2].replace(/\/$/, "")
            );
            Object.assign(acc.matchedParams, {
              [p]: Object.assign(acc.matchedParams[p] || {}, {
                [index]: decodedParamSegment
              })
            });
            return acc;
          },
          {
            pos: -1,
            matchedParams: {}
          }
        );
        var matchedParams = matchResult.matchedParams || {};
        routes = config.routeNames.map(function(name) {
          var _routeConfig_pattern_replace;
          var routeConfig = configs.find(function(c) {
            return c.screen === name && config.pattern.startsWith(c.pattern);
          });
          var normalizedPath = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.path.split("/").filter(Boolean).join("/");
          var numInitialSegments = routeConfig === null || routeConfig === void 0 ? void 0 : (_routeConfig_pattern_replace = routeConfig.pattern.replace(new RegExp(`${(0, import_escape_string_regexp.default)(normalizedPath)}$`), "")) === null || _routeConfig_pattern_replace === void 0 ? void 0 : _routeConfig_pattern_replace.split("/").length;
          var params = normalizedPath === null || normalizedPath === void 0 ? void 0 : normalizedPath.split("/").reduce(function(acc, p, index) {
            var _matchedParams_p;
            if (!(0, import_shared.isDynamicPart)(p)) {
              return acc;
            }
            var offset = numInitialSegments ? numInitialSegments - 1 : 0;
            var value = (0, import_shared.getParamValue)(p, (_matchedParams_p = matchedParams[p]) === null || _matchedParams_p === void 0 ? void 0 : _matchedParams_p[index + offset]);
            if (value) {
              var _routeConfig_parse;
              var key = (0, import_shared.replacePart)(p);
              acc[key] = (routeConfig === null || routeConfig === void 0 ? void 0 : (_routeConfig_parse = routeConfig.parse) === null || _routeConfig_parse === void 0 ? void 0 : _routeConfig_parse[key]) ? routeConfig.parse[key](value) : value;
            }
            return acc;
          }, {});
          if (params && Object.keys(params).length) {
            Object.assign(allParams, params);
            return {
              name,
              params
            };
          }
          return {
            name
          };
        });
        remainingPath = remainingPath.replace(match[1], "");
        return "break";
      }
    };
    for (var _iterator = configs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ret = _loop();
      if (_ret === "break") break;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  (0, import_getStateFromPath_mods.populateParams)(routes, allParams);
  return {
    routes,
    remainingPath
  };
};
var createNormalizedConfigs = function createNormalizedConfigs1(screen, routeConfig) {
  var routeNames = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], initials = arguments.length > 3 ? arguments[3] : void 0, parentScreens = arguments.length > 4 ? arguments[4] : void 0, parentPattern = arguments.length > 5 ? arguments[5] : void 0;
  var configs = [];
  routeNames.push(screen);
  parentScreens.push(screen);
  var config = routeConfig[screen];
  if (typeof config === "string") {
    var pattern = parentPattern ? joinPaths(parentPattern, config) : config;
    configs.push(createConfigItem(screen, routeNames, pattern, config));
  } else if (typeof config === "object") {
    var pattern1;
    if (typeof config.path === "string") {
      if (config.exact && config.path === void 0) {
        throw new Error("A 'path' needs to be specified when specifying 'exact: true'. If you don't want this screen in the URL, specify it as empty string, e.g. `path: ''`.");
      }
      pattern1 = config.exact !== true ? joinPaths(parentPattern || "", config.path || "") : config.path || "";
      configs.push(createConfigItem(screen, routeNames, pattern1, config.path, config.parse, config));
    }
    if (config.screens) {
      if (config.initialRouteName) {
        initials.push({
          initialRouteName: config.initialRouteName,
          parentScreens
        });
      }
      Object.keys(config.screens).forEach(function(nestedConfig) {
        var result = createNormalizedConfigs(nestedConfig, config.screens, routeNames, initials, [
          ...parentScreens
        ], pattern1 !== null && pattern1 !== void 0 ? pattern1 : parentPattern);
        configs.push(...result);
      });
    }
  }
  routeNames.pop();
  return configs;
};
var createConfigItem = function createConfigItem2(screen, routeNames, pattern, path) {
  var parse = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0, config = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
  pattern = pattern.split("/").filter(Boolean).join("/");
  var regex = pattern ? new RegExp(`^(${pattern.split("/").map(function(it) {
    if (it.startsWith(":")) {
      return `(([^/]+\\/)${it.endsWith("?") ? "?" : ""})`;
    }
    return `${it === "*" ? ".*" : (0, import_escape_string_regexp.default)(it)}\\/`;
  }).join("")})`) : void 0;
  return {
    screen,
    regex,
    pattern,
    path,
    // The routeNames array is mutated, so copy it to keep the current state
    routeNames: [
      ...routeNames
    ],
    parse,
    // @modified - start
    ...(0, import_getStateFromPath_mods.createConfigItemAdditionalProperties)(screen, pattern, routeNames, config)
  };
};
var findParseConfigForRoute = function findParseConfigForRoute2(routeName, flatConfig) {
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = flatConfig[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var config = _step.value;
      if (routeName === config.routeNames[config.routeNames.length - 1]) {
        return config.parse;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return void 0;
};
var findInitialRoute = function findInitialRoute2(routeName, parentScreens, initialRoutes) {
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = initialRoutes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var config = _step.value;
      if (parentScreens.length === config.parentScreens.length) {
        var sameParents = true;
        for (var i = 0; i < parentScreens.length; i++) {
          if (parentScreens[i].localeCompare(config.parentScreens[i]) !== 0) {
            sameParents = false;
            break;
          }
        }
        if (sameParents) {
          return routeName !== config.initialRouteName ? config.initialRouteName : void 0;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return void 0;
};
var routeKeyCounter = 0;
function resetRouteKeyCounter() {
  routeKeyCounter = 0;
}
function getRouteWithKey(route) {
  var key = `${route.name}-${routeKeyCounter++}`;
  if (process.env.ONE_DEBUG_ROUTER) {
    console.info(`[one] getRouteWithKey: ${route.name} -> key=${key}`);
  }
  return {
    ...route,
    key
  };
}
var createStateObject = function createStateObject2(initialRoute, route, isEmpty) {
  if (isEmpty) {
    if (initialRoute) {
      return {
        index: 1,
        // @modified: add deterministic keys
        routes: [
          getRouteWithKey({
            name: initialRoute
          }),
          getRouteWithKey(route)
        ]
      };
    } else {
      return {
        // @modified: add deterministic keys
        routes: [
          getRouteWithKey(route)
        ]
      };
    }
  } else {
    if (initialRoute) {
      return {
        index: 1,
        // @modified: add deterministic keys
        routes: [
          getRouteWithKey({
            name: initialRoute
          }),
          getRouteWithKey({
            ...route,
            state: {
              routes: []
            }
          })
        ]
      };
    } else {
      return {
        // @modified: add deterministic keys
        routes: [
          getRouteWithKey({
            ...route,
            state: {
              routes: []
            }
          })
        ]
      };
    }
  }
};
var createNestedStateObject = function createNestedStateObject2(param, routes, initialRoutes, flatConfig) {
  var { path, ...restPathData } = param;
  var route = routes.shift();
  var parentScreens = [];
  var initialRoute = findInitialRoute(route.name, parentScreens, initialRoutes);
  parentScreens.push(route.name);
  var state = createStateObject(initialRoute, route, routes.length === 0);
  if (routes.length > 0) {
    var nestedState = state;
    while (route = routes.shift()) {
      initialRoute = findInitialRoute(route.name, parentScreens, initialRoutes);
      var nestedStateIndex = nestedState.index || nestedState.routes.length - 1;
      nestedState.routes[nestedStateIndex].state = createStateObject(initialRoute, route, routes.length === 0);
      if (routes.length > 0) {
        nestedState = nestedState.routes[nestedStateIndex].state;
      }
      parentScreens.push(route.name);
    }
  }
  route = (0, import_findFocusedRoute.findFocusedRoute)(state);
  route.path = restPathData.pathWithoutGroups;
  var params = (0, import_getStateFromPath_mods.parseQueryParamsExtended)(path, route, flatConfig ? findParseConfigForRoute(route.name, flatConfig) : void 0, restPathData.hash);
  if (params) {
    route.params = {
      ...route.params,
      ...params
    };
  }
  return state;
};
//# sourceMappingURL=getStateFromPath.js.map
